import { render, staticRenderFns } from "./RankingHeader.vue?vue&type=template&id=c38b0430&scoped=true"
import script from "./RankingHeader.vue?vue&type=script&lang=js"
export * from "./RankingHeader.vue?vue&type=script&lang=js"
import style0 from "./RankingHeader.vue?vue&type=style&index=0&id=c38b0430&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c38b0430",
  null
  
)

export default component.exports